import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { useSwitchForm } from './hook';
import { SwitchCallInfo } from './callInfo';
import FormView from '../../../../components/views/formView';
import { SwitchFormProps } from './props';
import {
    isOnlyViewProfile,
    isSupervisor,
} from '../../../../../shared/types/profiles';
import { RootState } from '../../../../../redux/store';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { SWITCH, SWITCH_DETAIL } from '../../../../../routes/paths';
import SwitchFunctionaryInfo from './functionaryInfo';

export const SwitchForm = ({ showFormView }: SwitchFormProps) => {
    const {
        switchDetail,
        functionarySwitchDetail,
        loading,
        handleSubmit,
        handleClean,
        setFormikSwitch,
        setFormikSwitchFunctionaryInfo,
    } = useSwitchForm();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [showHistorical, setShowHistorical] = useState(false);
    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    const additionalButtons =
        !isSupervisor(type) && !isOnlyViewProfile(type) ? (
            <ActionButtonGroup
                id={switchDetail?.id || ''}
                buttonCreate={{
                    show: false,
                }}
                buttonSearch={{
                    show: true,
                    route: SWITCH,
                }}
                buttonView={{
                    show: !isOnlyViewProfile(type),
                    route: SWITCH_DETAIL,
                }}
                buttonLog={{
                    show: false,
                }}
                onHistoricalShow={toggleHistorical}
            />
        ) : undefined;

    return (
        <>
            {showFormView && (
                <FormView
                    title={
                        switchDetail && switchDetail.id
                            ? 'Editar Conmutador'
                            : 'Crear Conmutador'
                    }
                    additionalButtons={additionalButtons}
                />
            )}
            <SwitchCallInfo
                data={switchDetail}
                onChangeFormik={(formik) => setFormikSwitch(formik)}
            />
            <SwitchFunctionaryInfo
                data={functionarySwitchDetail}
                onChangeFormik={(formik) =>
                    setFormikSwitchFunctionaryInfo(formik)
                }
            />

            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                {(!switchDetail || !switchDetail.id) && (
                    <LoadingButtonGeneral
                        disabled={loading}
                        title="Limpiar"
                        variant="outlined"
                        onClick={handleClean}
                    />
                )}
            </Grid>
        </>
    );
};
